import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import n, { useEffect as B } from "react";
import { Popover as s, Portal as h } from "@headlessui/react";
import { useSelectPopper as G } from "./use-select-popper";
var $ = function $(t, e) {
    if (e === "all") {
      var o = t == null ? void 0 : t.totalCount;
      return o ? "".concat(o, " guest").concat(o > 1 ? "s" : "") : "";
    }
    if (e === "each") {
      var _o = "";
      return t.value.forEach(function (r) {
        var a = _o ? " | " : "";
        !r.value || (_o = _o.concat("".concat(a).concat(r.value, " ").concat(r.name)));
      }), _o;
    }
    return e == null ? void 0 : e(t);
  },
  A = function A(_ref) {
    var t = _ref.form,
      e = _ref.name,
      o = _ref.menu,
      r = _ref.option,
      a = _ref.menuContainer,
      m = _ref.inputComponent,
      u = _ref.okButton,
      _ref$okText = _ref.okText,
      y = _ref$okText === void 0 ? "Ok" : _ref$okText,
      T = _ref.placeholder,
      C = _ref.offset,
      _ref$countTextFormat = _ref.countTextFormat,
      f = _ref$countTextFormat === void 0 ? "all" : _ref$countTextFormat,
      g = _ref.portal;
    var l;
    var k = ((l = t == null ? void 0 : t.state) == null ? void 0 : l[e]).value,
      _G = G({
        offset: C
      }),
      p = _G.element,
      x = _G.setElement,
      E = _G.setPopper,
      F = _G.styles,
      P = _G.attributes;
    B(function () {
      t.refs[e].current = p;
    }, [p]);
    var v = $(t.state[e], f),
      S = function S() {
        p == null || p.click();
      },
      O = g || h;
    return n.createElement(s, {
      as: n.Fragment
    }, function (_ref2) {
      var c = _ref2.open;
      return n.createElement(n.Fragment, null, n.createElement(s.Button, {
        value: v,
        ref: x,
        as: m,
        placeholder: T,
        name: e,
        form: t,
        readOnly: !0
      }), n.createElement(O, null, n.createElement(s.Panel, _objectSpread({
        as: a,
        ref: E,
        static: !0,
        style: _objectSpread(_objectSpread({}, F.popper), {}, {
          pointerEvents: c ? "" : "none"
        })
      }, P.popper), n.createElement(o, {
        open: c
      }, k.map(function (i) {
        return n.createElement(r, {
          key: i.name,
          form: t,
          name: e,
          option: i
        });
      }), !!u && n.createElement(u, {
        onClick: S
      }, y)))));
    });
  };
export { A as GuestSelect };